import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify'
import { Container, Col, Card } from 'reactstrap'
import styled from 'styled-components'
import ContentModal from '../../components/Modals/ContentModal'
import contentImg from '../../assets/content.png'
import fileImg from '../../assets/file.png'
import archiveImg from '../../assets/archive.png'
import externalLinkImg from '../../assets/link-externo.png'
import simuladoImg from '../../assets/simulado.png'
import videoImg from '../../assets/video.png'
import ContentTypeEnum from '../../helpers/enums/contentType'
import { AuthContext } from '../../contexts/AuthContext'
import api from '../../services/api';
import _ from 'lodash';
import { NavLink } from 'react-router-dom';

const StyledContainer = styled(Container)`
  padding: 50px 60px;
  overflow-x: hidden;
  color: #004C70;
`

const Title = styled.div`
  font-size: 40px;
  font-weight: bold;
  text-transform: uppercase;
`;

const ClassContent = styled.div`
  font-size: 18px;
`;

const SubTitle = styled.div`
  font-size: 26px;
  font-weight: bold;
`;

const ClassFiles = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const ClassFile = styled(Card)`
  height: 100px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: unset;
  border-radius: 10px;
  &:hover {
    background-color: #cccc;
    cursor: pointer;
  }
`;

const ClassFileName = styled.div`
  font-size: 10px;
  font-weight: bold;
  text-align: center;
`;

const ContentSectionTitle = styled.h3`
  font-size: 26px;
  font-weight: bold;
  margin-top: 5px;
`;

const ClassFragment = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 25px;
  border-bottom: 1px solid #ddd;
  flex: 1;
  flex-wrap: wrap;
`;

function Classe(props) {
  const { dispatch } = useContext(AuthContext);
  const [currentClass, setCurrentClass] = useState({})
  const [modalVisibility, setModalVisibility] = useState(false);
  const [currentContent, setCurrentContent] = useState({});
  const [classContentHTML, setClassContentHTML] = useState(null)

  useEffect(() => {
    dispatch({ type: "BLOCK_UNBLOCK_UI" })
    api.get(`/lecture/${props.match.params.id}`).then(res => {
      dispatch({ type: "BLOCK_UNBLOCK_UI" })
      setCurrentClass(res.lecture)
      const auxContent = res.lecture.contents.filter(c => c.type === ContentTypeEnum.HTML);
      if (auxContent.length > 0)
        setClassContentHTML(auxContent[0])
    }).catch(err => {
      toast.error("Ops, parece que algo deu errado!")
    })
  }, [dispatch, props.match.params.id])

  const toggleModal = (content) => {
    setModalVisibility(!modalVisibility);
    setCurrentContent(content)
  }

  const goToExam = (mockTest) => {
    props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.id}/exams/${mockTest}`)
  }

  const getContentIcon = (content) => {
    switch (content.type) {
      case ContentTypeEnum.POST:
        return <img src={contentImg} style={{ width: 50 }} />
      case ContentTypeEnum.YOUTUBE:
        return <img src={videoImg} style={{ width: 50 }} />
      case ContentTypeEnum.EXTERNAL_LINK:
        return <img src={externalLinkImg} style={{ width: 50 }} />
      case ContentTypeEnum.HTML:
        return <img src={contentImg} style={{ width: 50 }} />
      default:
        return <img src={archiveImg} style={{ width: 50 }} />
    }
  }

  const mountGroupped = () => {
    return <ClassFragment>
      {currentClass.contents.filter(c => c.type !== ContentTypeEnum.HTML).map((content, index) => {
        return <div key={`content_${content._id}`} style={{ marginRight: 30, marginBottom: 10 }}>
          {content.type === ContentTypeEnum.EXTERNAL_LINK || content.type === ContentTypeEnum.FILE ?
            <a href={content.type === ContentTypeEnum.EXTERNAL_LINK ? content.link : `${process.env.REACT_APP_HOST}/static/${content.fileName}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#004C70' }}>
              <ClassFile>
                {getContentIcon(content)}
                <ClassFileName>{content.name}</ClassFileName>
              </ClassFile>
            </a>
            : <ClassFile onClick={() => toggleModal(content)}>
              {getContentIcon(content)}
              <ClassFileName>{content.name}</ClassFileName>
            </ClassFile>}
        </div>
      })}
    </ClassFragment>
  }

  return (
    <StyledContainer>
      <Title>
        {currentClass.title}
      </Title>
      <ClassContent>
        {currentClass.description}
      </ClassContent>
      <hr />
      <ClassFiles>
        {classContentHTML && <ContentSectionTitle>Conteúdo Programático</ContentSectionTitle>}
        {classContentHTML && <ClassFragment>
          <div style={{marginBottom: 10 }}>
            <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`/course/${props.match.params.courseId}/class/${props.match.params.id}/highlighter/${classContentHTML._id}`}>
              <ClassFile>
                {getContentIcon(classContentHTML)}
              </ClassFile>
            </NavLink>
          </div>
        </ClassFragment>}
        {currentClass.contents && <>
          <ContentSectionTitle>Material Complementar</ContentSectionTitle>
          {mountGroupped()}
        </>}
        {currentClass.mockTest && <ContentSectionTitle>Simulado</ContentSectionTitle>}
        {currentClass.mockTest && <ClassFragment>
          <div style={{marginBottom: 10 }}>
            <ClassFile onClick={() => goToExam(currentClass.mockTest)}>
              <img src={simuladoImg} style={{ width: 50 }} />
            </ClassFile>
          </div>
        </ClassFragment>}
      </ClassFiles>
      <ContentModal isOpen={modalVisibility} toggle={toggleModal} content={currentContent} />
    </StyledContainer>
  );
}

export default Classe;